import { useTranslation } from 'react-i18next';
import { ErrorEnum } from './error.enum';
import { getApiErrorMessages } from './helpers';

export const useErrorMessage = (code?: ErrorEnum): { title: string; message: string } => {
  const { t } = useTranslation();
  const { title, message } = getApiErrorMessages(code);

  return {
    title: t(title.key, { defaultValue: title.defaultValue }),
    message: t(message.key, { defaultValue: message.defaultValue }),
  };
};
